<template>
  <div>
    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{modalHeader}}</v-col>
          <v-spacer />
         
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4"
        ><v-row justify="space-between">
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- eslint-disable -->
          <template v-slot:item.Title="{ item }">
            {{ item.IdeaItems[0].Title }}
          </template>
          <template v-slot:item.Avatar="{ item }">
            <v-tooltip bottom v-for="(obj, index) in item.Members" :key="obj.UserId">
      <template v-slot:activator="{ on }">
        <v-avatar size="60" class="avatar-item" v-on="on">
          <v-img
            :lazy-src="obj.Avatar"
            max-height="100"
            max-width="100"
            :src="obj.Avatar"
          ></v-img>
        </v-avatar>
      </template>
      <span>{{ obj.FullName }}</span>
    </v-tooltip>
          </template>
          <template v-slot:item.Type="{ item }">
            <v-chip
              v-if="item.Type == 2"
              class="ma-2"
              small
              color="green"
              text-color="white"
            >
            {{ $t("labels.team") }}
            </v-chip>
            <v-chip
              v-if="item.Type == 0"
              class="ma-2"
              small
              color="orange"
              text-color="white"
            >
              {{ $t("labels.anonim") }}
            </v-chip>
            <v-chip
              v-if="item.Type == 1"
              class="ma-2"
              small
              color="orange"
              text-color="white"
            >
            {{ $t("labels.individual") }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="item.IdeaItems[0].FileIds.length != 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="downloadFile(item.IdeaItems[0].FileIds[0])"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t("labels.seeFile") }}</span>
            </v-tooltip>
              
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BadgeService from "../services/BadgeService";
import InnovationService from "../services/InnovationService";
import DeleteModal from "../components/General/DeleteModal";
export default {
  data: () => ({
    innovationId: null,

    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],

    headers: [],
    //Loading states
    loadings: {
      table: false,
      select: false,
      send: false,
    },
    modalHeader: "", //Global header for opened modal
    //Group

    //Pagination models
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
    badgeTypeList: [
      { Name: "Başarı Rozetleri", Value: 0 },
      { Name: "Katılım Rozetleri", Value: 1 },
      { Name: "Tümü", Value: 2 },
    ],
  }),

  watch: {},
  mounted() {
    this.setup();
    this.getTableList();
  },
  components: {
    DeleteModal,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    setup() {
      this.innovationId = this.$route.query.id;
      this.$route.query.id != null ? this.getLeaderBoard() : null;
      this.headers = [
      {
          text: this.$t("title.JoinType"),
          value: "Type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.notificationUsers"),
          value: "Avatar",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.Score"),
          value: "TotalScore",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderLikeCount"),
          value: "LikeCount",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderCommentCount"),
          value: "CommentCount",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderIdeaTitle"),
          value: "Title",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
    },
    downloadFile(url) {
      window.open(url, "_blank");
    },
    getLeaderBoard() {
        this.$store.state.loadingStatus = true;
      InnovationService.getLeaderboard(1, 10, this.innovationId)
        .then((res) => {
          this.tableData = res.data.Result;
          this.modalHeader=this.tableData[0].InnovationTitle + " Skor Tablosu"; 
          this.pagination.totalItems = res.data.TotalItems;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    //Fill's the emergency list
    getTableList() {
      this.$store.state.loadingStatus = true;

      BadgeService.getBadges(
        this.pagination.page,
        this.pagination.rowsPerPage,
        this.badgeType
      )
        .then((res) => {
          this.tableData = res.data.Result;
          this.pagination.totalItems = res.data.TotalItems;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    goDetail(id) {
      this.$router.push({
        name: `badgeManagement`,
        query: { id },
      });
    },

    getMarkerIcon(item) {
      if (item.SafetyStatus === 1)
        return require("../../public/img/PersonInDanger.png");
      else {
        return require("../../public/img/PersonNotInDanger.png");
      }
    },

    openMarkerInfo(item) {
      this.selectedMarker = item;
      this.markerModalShow = true;
    },

    getTitleColor(item) {
      if (item.SafetyStatus === 0) return "green";
      else {
        return "error";
      }
    },

    clearPage() {},

    clearModal() {},
    openTopList() {},

    downloadExcel(item) {
      this.$store.state.loadingStatus = true;
      EmergencyServices.downloadEmergencyReport(item.Id, item.Title)
        .then((res) => {
          console.log("Download res >> ", res);
        })

        .catch((err) => {
          console.log("ERR >> ", err.Message);
          window.showInfo(
            this.$t("description.emergencyDownloadError"),
            "standart",
            "info"
          );
        })
        .then(() => {
          // this.loadings.table = false;
          this.$store.state.loadingStatus = false;
        });
    },
    selectBadge() {
      this.badgeType = this.selectedBadgeType.Value;
      this.getTableList();
    },
    //Opens modal for deletion operation
    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    //Delete operation
    deleteItem() {
      this.$store.state.loadingStatus = true;
      BadgeService.deleteBadge(this.deleteItemModel.Id)
        .then(() => {
          this.getTableList();
          this.clearPage();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          // this.loadings.table = false;
          this.$store.state.loadingStatus = false;
        });
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
  },
};
</script>
<style>

.avatar-container {
  display: flex;
}

.avatar-item {
    margin-left: -30px;
}
</style>

